import { useEffect } from 'react';

export function useTaskKeyFromUrl(
  loanIdParam: string | undefined,
  searchParams: URLSearchParams,
  setSearchParams: (nextParams: URLSearchParams, opts?: { replace?: boolean }) => void,
  setTaskOpenModal: ((key: string) => void) | undefined
) {
  useEffect(() => {
    const taskKeyFromUrl = searchParams.get('taskKey');
    if (loanIdParam && taskKeyFromUrl && setTaskOpenModal) {
      setTaskOpenModal(decodeURIComponent(taskKeyFromUrl));
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete('taskKey');
      setSearchParams(nextParams, { replace: true });
    }
  }, []);
}
